import styled from 'styled-components';

import { StyledModal } from '../../../../components/Modal/styles';

export const StyledPreferenceInnerModal = styled(StyledModal)<{ isOpen: boolean; isTransitioning: boolean }>`
  position: fixed;
  width: calc(100% - 32px);
  right: ${({ isOpen }) => (isOpen ? '16px' : '460px')};
  top: 16px;
  background: white;
  transition: ${({ isOpen }) =>
    isOpen ? 'right 0.15s ease-in-out' : 'opacity 0.15s ease-out, right 0s 0.15s ease-in-out'};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  visibility: ${({ isOpen, isTransitioning }) => (isOpen || isTransitioning ? 'visible' : 'hidden')};
  overflow: visible;
`;

export const StyledPreferenceContent = styled.div`
  width: 100%;
`;
